import React from "react";
import { connect } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { bindActionCreators } from 'redux';

import {
    Button
} from 'reactstrap';

import { ApplicationState } from '../../Store';
import { actionCreators as AppActions } from '../../Store/AppSettings';
import { actionCreators as UserActions } from '../../Store/User';

type InjectedReduxState = {
}

type InjectedActionCreators = typeof AppActions & typeof UserActions;

type LogoutButtonProps = {
    buttonText?: string;
    style?: any;
}

type Props = InjectedReduxState & InjectedActionCreators & LogoutButtonProps;

const LogoutButtonComponent: React.FC<Props> = (props): React.ReactElement => {
    const { logout } = useAuth0();

    return (
        <Button
            type="button"
            style={props.style}
            className={'small'}
            onClick={() => {
                props.LogUserOut(logout);
            }}
            color="primary"
        >
            { props.buttonText || 'Log Out'}
        </Button>
    );
};

const LogoutButton = connect<InjectedReduxState, InjectedActionCreators, LogoutButtonProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result = {
        };

        return result;
    },
    dispatch => bindActionCreators({
            ...AppActions,
            ...UserActions,
        },
        dispatch
    )
)(LogoutButtonComponent);

export default LogoutButton;
